module.exports = __webpack_public_path__ + "img/Asheville-01.7d29297a.jpg";